import { GET_MENU, MENU_ERROR } from "../types";

export default (state, action) => {
  switch (action.type) {
    case GET_MENU:
      return {
        ...state,
        menu: action.payload,
        loading: false
      };
    case MENU_ERROR:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};
